<template>
  <v-dialog v-model="dialog" width="300" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-title>Refund Payment</v-list-item-title>
      </v-list-item>
    </template>

    <v-card>
      <ModelTitle title="Refund Payment" @close="close()" />


      <v-card-text>
        <div class="text-center px-10 mt-5">
          <v-text-field :disabled="settledDate ? false : true" outlined :max="selectedPayment.amount" dense hide-details
            class="al-r" v-model="amount" label="Refund Amount"></v-text-field>
        </div>

        <div v-if="transactionLoading">
          <div v-if="!settledDate" class="caption mt-2 text-center red--text">Transaction Not Yet Settled – Refund Not
            Allowed, Only Void Available</div>
          <div v-if="transaction && transaction.status_details && transaction.status_details.status"
            class="caption mt-2 text-center red--text">Transaction {{ transaction.status_details.status }}</div>
        </div>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="transactionLoading">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn v-if="!settledDate" :loading="isLoading" color="secondary" @click="voidTransaction">
          Void
        </v-btn>
        <v-btn v-else :loading="isLoading" color="primary" @click="submit">
          Refund
        </v-btn>

      </v-card-actions>
      <v-card-actions v-else>
        <v-progress-linear class="my-3" indeterminate></v-progress-linear>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import payCompassService from "@/modules/PayCompass/service.js";
// import paymentService from "@/modules/Donors/Payment/service.js";

export default {
  name: 'refund-payment',
  props: ['selectedPayment'],
  data() {
    return {
      dialog: false,
      amount: 0,
      isLoading: false,
      settledDate: null,
      transactionLoading: true,
      transaction: null,
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.amount = this.selectedPayment.amount
        // console.log('selectedPayment', this.selectedPayment)
        if (this.selectedPayment.stripeChargeId) {
          this.getTransaction()
        }
      }
    },
  },
  methods: {
    getTransaction() {
      if (this.selectedPayment.stripeChargeId) {
        this.transactionLoading = false
        console.log('metadata', this.selectedPayment)

        return payCompassService
          .getTransaction(this.selectedPayment.stripeChargeId)
          .then((result) => {
            this.transaction = result.data
            this.settledDate = result.data.settled_date
            this.transactionLoading = true
            console.log("refund card", result);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    },
    close() {
      this.dialog = false
    },
    voidTransaction() {
      // console.log('selectedPayment', this.selectedPayment)
      this.$swal({
        title: "Are you sure?",
        text: "You want to Void this transaction. You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$emit('submit')
          let voidTransaction = {
            referenceNumber: this.selectedPayment.stripeChargeId,
            amount: this.amount,
            orgAmount: this.selectedPayment.amount,
            id: this.selectedPayment.id,
          }
          return payCompassService
            .voidTransaction(voidTransaction)
            .then((result) => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: 'Transaction was voided',
                });
              this.$emit("submit");
              // this.getCards();
              // this.getCustomer();
              this.isLoading = false;
              this.close()
              console.log("refund card", result);
            })
            .catch((error) => {
              this.isLoading = false;
              this.$swal('Refund', error.data.message, 'error')
              // this.$swal
              //   .mixin({
              //     toast: true,
              //     position: "top-end",
              //     showConfirmButton: false,
              //     timer: 3000,
              //   })
              //   .fire({
              //     icon: "error",
              //     title: error.data.message,
              //   });
              console.log("error", error);
            });
        }
      });

    },
    submit() {
      console.log('selectedPayment', this.selectedPayment)
      let refundTransaction = {
        referenceNumber: this.selectedPayment.stripeChargeId,
        amount: this.amount,
        orgAmount: this.selectedPayment.amount,
        id: this.selectedPayment.id,
      }
      console.log('refundTransaction', refundTransaction)

      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$emit('submit')

          return payCompassService
            .refundCharge(refundTransaction)
            .then((result) => {
              this.$emit("submit");
              // this.getCards();
              // this.getCustomer();
              this.isLoading = false;
              console.log("refund card", result);
            })
            .catch((error) => {
              this.isLoading = false;
              this.$swal('Refund', error.data.message, 'error')
              // this.$swal
              //   .mixin({
              //     toast: true,
              //     position: "top-end",
              //     showConfirmButton: false,
              //     timer: 3000,
              //   })
              //   .fire({
              //     icon: "error",
              //     title: error.data.message,
              //   });
              console.log("error", error);
            });
        }
      });

    }
  },
}
</script>

<style scoped></style>